export const API = "https://mam08nign4.execute-api.us-west-1.amazonaws.com/prod";
export const clientUrl = "https://www.musicvanzari.com";
// LOCAL API URL: http://localhost:8080
// LOCAL CLIENT = http://localhost:3000
